require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-jesse-hamlin.json") })
        }
      }, "path---blog-author-jesse-hamlin");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-jesse-hamlin!./.cache/json/blog-author-jesse-hamlin.json
// module id = 655
// module chunks = 231608221292675